import React from 'react'

function Abstract() {
  return (
    <div>
      <p className='header_context'>Abstract</p>
      <p className='context'>
     This presents a comprehensive analysis of various machine learning models used for movie recommendation systems based on the MovieLens dataset. The models explored include Collaborative Filtering, Content-Based Filtering, Hybrid Filtering, Naive Bayes Approach, and Logistic Regression Approach. Each model's methodology, implementation details, results, and challenges are discussed in detail. Collaborative Filtering leverages user-item interactions, while Content-Based Filtering focuses on movie attributes. The Hybrid Filtering combines both approaches to enhance recommendation accuracy. Naive Bayes and Logistic Regression offer additional methods for genre classification and personalized recommendations. The study concludes that Hybrid Filtering outperforms individual approaches by providing more accurate and diverse recommendations tailored to user preferences. Each team member's contributions to the project are also outlined.
      </p>
    </div>
  )
}

export default Abstract
